import data from './data'
import components from './components'

export default {
  data,
  components,
  resourcePath: '/v1/term'
}



// WEBPACK FOOTER //
// ./src/app/auth/terms/term/resources/index.js